/**
 * Review service
 */
import api from './api';

export const reviewService = {
  /**
   * Get feed
   */
  async getFeed() {
    const response = await api.get('/api/reviews/feed');
    return response.data;
  },

  /**
   * Get creator reviews
   */
  async getCreatorReviews(creatorId) {
    const response = await api.get(`/api/reviews/creator/${creatorId}`);
    return response.data;
  },

  /**
   * Get my reviews (current user's reviews)
   */
  async getMyReviews() {
    // The backend will determine the current user from the auth token
    // and return their reviews via the /me endpoint or similar
    // For now, we need to get the current user's ID and fetch their creator reviews
    const response = await api.get('/api/reviews/my');
    return response.data;
  },

  /**
   * Create review
   */
  async createReview(reviewData) {
    console.log('[ReviewService] Creating review with data:', reviewData);
    console.log('[ReviewService] Data structure:', {
      hasRestaurant: !!reviewData.restaurant,
      restaurantKeys: reviewData.restaurant ? Object.keys(reviewData.restaurant) : [],
      hasDescription: !!reviewData.description,
      photosCount: reviewData.photos?.length,
      dishesCount: reviewData.dishes?.length,
      rating: reviewData.rating,
      visibility: reviewData.visibility
    });
    
    try {
      const response = await api.post('/api/reviews', reviewData);
      console.log('[ReviewService] Review created successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('[ReviewService] Error creating review:', error);
      console.error('[ReviewService] Error response:', error.response?.data);
      throw error;
    }
  },

  /**
   * Save review
   */
  async saveReview(reviewId) {
    console.log('[ReviewService] Saving review:', reviewId);
    try {
      const response = await api.post(`/api/saved/${reviewId}`);
      console.log('[ReviewService] Review saved successfully');
      return response.data;
    } catch (error) {
      console.error('[ReviewService] Error saving review:', error);
      throw error;
    }
  },

  /**
   * Unsave review
   */
  async unsaveReview(reviewId) {
    console.log('[ReviewService] Unsaving review:', reviewId);
    try {
      const response = await api.delete(`/api/saved/${reviewId}`);
      console.log('[ReviewService] Review unsaved successfully');
      return response.data;
    } catch (error) {
      console.error('[ReviewService] Error unsaving review:', error);
      throw error;
    }
  },

  /**
   * Get saved reviews
   */
  async getSavedReviews() {
    const response = await api.get('/api/saved');
    return response.data;
  },

  /**
   * Get saved (alias for getSavedReviews)
   */
  async getSaved() {
    return this.getSavedReviews();
  },

  /**
   * Check if review is saved
   */
  async checkSaved(reviewId) {
    const response = await api.get(`/api/saved/check/${reviewId}`);
    return response.data;
  }
};
